import { getConversation as publicGetConversation } from './innovation-widget-v1-conversation-conversations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getConversation: MaybeContext<
  BuildRESTFunction<typeof publicGetConversation> & typeof publicGetConversation
> = /*#__PURE__*/ createRESTModule(publicGetConversation);

export { WebhookIdentityType } from './innovation-widget-v1-conversation-conversations.universal.js';
export {
  Conversation,
  ConversationParticipantIdOneOf,
  GetConversationRequest,
  GetConversationResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
} from './innovation-widget-v1-conversation-conversations.universal.js';
export { WebhookIdentityTypeWithLiterals } from './innovation-widget-v1-conversation-conversations.universal.js';
